// extracted by mini-css-extract-plugin
export default {"order_details_block":"order-details_order_details_block__6fKWf","image":"order-details_image__YEti2"};